/* eslint-disable */
import store from '@/store';
import invoiceStatusList from '@/constants/invoiceStatus';
const aggrigate = ['contract_charge', 'unloading_charge', 'loading_charge', 'lr_charge', 'loading_detention_charge', 'unloading_detention_charge', 'extra_charges', 'oda_charges', 'additional_point_charges', ];
class Invoice {
 static getMainStatusId() {
  const mainStatusId = store.state.invoice.filter.mainStatus;
  const statusId = store.state.invoice.filter.status;
  return {
   mainStatusId,
   statusId
  };
 }
 static getStatusName(id) {
  const extractStatus = invoiceStatusList.find(status => status.id === id)
  return extractStatus ? extractStatus.invoice_label : '';
 }
 static getStatusIds(statusNames) {
  return invoiceStatusList.filter(status => statusNames.includes(status.name)).map(status => status.id);
 }
 static getStatusId(statusName) {
  const extractStatus = invoiceStatusList.find(status => status.name === statusName)
  return extractStatus ? extractStatus.id : '';
 }
 static statusAccess(statusNames) {
  const Ids = this.getStatusIds(statusNames);
  const statusId = store.state.invoice.filter.status;
  return Ids.includes(statusId);
 }
 static hideVoucherActions() {
  return this.checkPermission(['hide_voucher_action']) ? !this.statusAccess(['librarian_accepted', 'payment_processing', 'payment_accepted']) : true;
 }
 static checkPermission(names) {
  const user = store.getters['app/currentUser'];
  const roles = user && user.permissions_list;
  return names.filter(val => roles.includes(val)).length;
 }
 static checkFeature(names) {
  const features = store.getters['app/features'];
  return names.filter(val => features.includes(val)).length;
 }
 static voucherView() {
  const {
   mainStatusId
  } = this.getMainStatusId();
  const voucherViewStatus = ['voucher_created', 'invoice_accepted', 'librarian_accepted', 'librarian_rejected', 'payment_processing', 'on_hold', 'payment_accepted', 'payment_rejected'];
  return mainStatusId !== 1 && this.statusAccess(voucherViewStatus);
 }
 static showExport() {
  const {
   mainStatusId
  } = this.getMainStatusId();
  const canExportOn = ['pending','payment_ready_for_voucher', 'checked', 'invoice_rejected', 'invoice_accepted', 'payment_re_submitted'];
  return this.statusAccess(canExportOn) && mainStatusId !== 2 && this.checkPermission(['verify_invoice', 'accept_invoice']);
 }
 static showGenerateVoucher() {
  const {
   mainStatusId
  } = this.getMainStatusId();
  return this.statusAccess(['invoice_accepted', 'payment_ready_for_voucher']) && mainStatusId === 1;
 }
 static showHoldApprove() {
  return this.statusAccess(['librarian_rejected']) && this.checkPermission(['verify_invoice', 'accept_invoice']);
 }
 static showVerify(status) {
  const {
   mainStatusId
  } = this.getMainStatusId();
  let onMainStatus = 1;
  if (status) {
   onMainStatus = 2;
  }
  return this.statusAccess(['invoice_accepted']) && mainStatusId === onMainStatus && this.checkPermission(['librarian_accept_invoice']);
 }
 static showPaid() {
  return this.statusAccess(['librarian_accepted', 'payment_processing']) && this.checkPermission(['accounts_accept_invoice']);
 }
 static showMiroExport(mainStatus, enabledVoucher) {
  if (enabledVoucher && mainStatus.id === 1) {
   return false;
  }
  return this.statusAccess(['voucher_created', 'librarian_accepted']) && this.checkPermission(['librarian_accept_invoice', 'accounts_accept_invoice']);
 }
 static showVoucherExport() {
  return this.statusAccess(['payment_processing', 'on_hold', 'payment_accepted']) && this.checkPermission(['accounts_accept_invoice']);
 }
 static showMiroImport() {
  return this.statusAccess(['librarian_accepted', 'payment_processing', 'on_hold', 'payment_accepted']) && this.checkPermission(['accounts_accept_invoice']);
 }
 static depot(lists = [], Id = '') {
  return lists.find(depot => depot.id === Id);
 }
 static canCheckedInvoice(status) {
  let checkStatus = [];
  if (this.checkFeature(['invoice_voucher'])) {
   checkStatus = this.getStatusIds(['voucher_created']);
  } else {
   checkStatus = this.getStatusIds(['pending']);
  }
  return checkStatus.includes(status);
 }
 static canEditInvoice(status) {
  let editStatusList = [];
  if (this.checkFeature(['invoice_voucher'])) {
   editStatusList = this.getStatusIds(['checked', 'payment_re_submitted', 'librarian_rejected', 'voucher_created']);
  } else {
   editStatusList = this.getStatusIds(['pending', 'checked', 'payment_re_submitted', 'librarian_rejected']);
  }
  return editStatusList.includes(status);
 }
  static canApproveInvoice(status) {
    let canApproveStatus = [];
    if (this.checkFeature(['invoice_voucher'])) {
        canApproveStatus = this.getStatusIds(['checked', 'invoice_rejected', 'librarian_rejected', 'librarian_rejected', 'payment_re_submitted'])
    } else {
        canApproveStatus = this.getStatusIds(['pending', 'checked', 'invoice_rejected', 'librarian_rejected', 'librarian_rejected', 'payment_re_submitted'])
    }
   return canApproveStatus.includes(status);
  }
 static canRejectInvoice(status) {
  return this.getStatusIds(['pending', 'checked', 'librarian_rejected', 'librarian_rejected', 'payment_re_submitted', 'voucher_created']).includes(status);
 }
 static total(payment, column = null) {
  return this.computePayment(payment);
 }
 static updateColumnAmount(payment, column) {
  const consignments = payment.client.consignment;
  payment.client[column] = 0;
  for (const i in consignments) {
   payment.client[column] += Number(consignments[i][column]);
  }
 }
 static decimalPoint(num) {
  return (num > 0) ? Number(num.toFixed(2)) : 0;
 }
 static computePayment(payment) {
  const sum = this.aggrigateFields(payment);
  return this.decimalPoint(sum);
 }
 static aggrigateFields(sectionobj, section = 'client') {
  let sum = 0;
  for (const i in aggrigate) {
   sum += Number(sectionobj[aggrigate[i]][section]);
  }
  sum -= Number(sectionobj.transit_charge[section]);
  sum -= Number(sectionobj.arrival_charge[section]);
  sum -= Number(sectionobj.shortage_charge[section]);
  sum -= Number(sectionobj.damage_charge[section]);
  sum -= Number(sectionobj.leakage_charge[section]);
  sum -= (sectionobj.carton_damage_charge ? Number(sectionobj.carton_damage_charge[section]) : 0);
  sum -= (sectionobj.wallet_penalty_charge ? Number(sectionobj.wallet_penalty_charge[section]) : 0);
  sectionobj.total_amount[section] = this.decimalPoint(sum);
  return sectionobj.total_amount[section];
 }
 static calculateTax(payment, sectionobj, total) {
  let taxamount = 0;
  // const sectionobj = payment.client;
  if (payment.same_state === 1) {
   taxamount = (payment.igst_tax / 100) * total;
  } else {
   const state = (payment.state_tax / 100) * total;
   const central = (payment.central_tax / 100) * total;
   taxamount = state + central;
  }
  if (taxamount < 0) {
   taxamount = 0;
  }
  if (payment.paid_to === 1) {
   sectionobj.service_charge = this.decimalPoint(taxamount);
   sectionobj.no_tax = 0;
  } else {
   sectionobj.service_charge = 0;
   sectionobj.no_tax = this.decimalPoint(taxamount);
  }
 }
 static invoiceTotal(payments = [], section = 'client') {
  let sum = 0;
  payments.forEach((item) => {
   sum += item.total_amount[section];
   // sum += item[section].service_charge;
  });
  return this.decimalPoint(sum);
 }
 static voucherTotal(invoices = [], section = 'client') {
  let sum = 0;
  invoices.forEach((item) => {
   item.order_payments.forEach((payment) => {
    payment.charges.forEach((indent) => {
     sum += indent.total_amount[section];
    });
   });
  });
  return this.decimalPoint(sum);
 }
 static checkNote(invoiceTotal, GstType) {
  let noteType = 2;
  let sumDifference = 0;
  const sumVendor = invoiceTotal.transporter;
  const sumClient = invoiceTotal.client;
  if (sumVendor > sumClient) {
   sumDifference = this.decimalPoint(sumVendor - sumClient);
   noteType = (GstType === 1) ? 1 : 2; // 1 credit 2 debit
  } else {
   noteType = (GstType === 1) ? 2 : 1;
   sumDifference = this.decimalPoint(sumClient - sumVendor);
  }
  return {
   GstType,
   noteType,
   sumDifference,
   number: (GstType === 1 && noteType === 1) ? '' : 'PND-' + Math.floor(100 + Math.random() * 900000),
  };
 }
 static invoiceTax(payments = [], firstPayment) {
  let payTax = 0;
  let rcmTaX = 0;
  let paidTax = 0;
  payments.forEach((item) => {
   payTax += item.client.service_charge;
   rcmTaX += item.client.no_tax;
  });
  if (firstPayment.paid_to === 1) {
   if (firstPayment.same_state === 2) {
    paidTax = payTax / 2;
   } else {
    paidTax = payTax;
   }
  } else {
   paidTax = rcmTaX;
  }
  return this.decimalPoint(paidTax);
 }
}
export default Invoice;